import Vue from "vue";
import VueRouter from "vue-router";
import Dashboard from "@/views/dashboard.vue";
import Login from "@/views/login.vue";
import PageNotFound from "@/views/404.vue";
import Export from "@/views/export/export.vue";
import Requests from "@/views/requests/requests.vue";
import ProjectsOverview from "@/views/projects/overview.vue";
import ProjectDetail from "@/views/projects/detail.vue";
import ProjectNew from "@/views/projects/new.vue";
import UrlDetail from "@/views/url/detail.vue";
import UrlEmpty from "@/views/url/empty.vue";
import UserResendConfirmation from "@/views/user/resend-confirmation.vue";
import UserResetPassword from "@/views/user/reset-password.vue";
import UserResetPasswordStep2 from "@/views/user/reset-password-step-2.vue";
import UserConfirmEmail from "@/views/user/confirm-email.vue";
import UserConfirmChangeEmail from "@/views/user/confirm-change-email.vue";
import Signup from "@/views/signup/signup.vue";
import SignupStep2 from "@/views/signup/signup-002.vue";

// Settings
import General from "@/views/settings/general.vue";
import Headers from "@/views/settings/headers.vue";
import Settings from "@/views/settings/settings.vue";

// Settings - Acount
import AccountDelete from "@/views/settings/account/delete.vue";
import Profile from "@/views/settings/account/profile.vue";
import Email from "@/views/settings/account/email.vue";
import Password from "@/views/settings/account/password.vue";

// Settings - Billing
import Billing from "@/views/settings/billing/billing.vue";

Vue.use(VueRouter);

const routes = [
  // Default
  {
    path: "/",
    redirect: "/requests",
    name: "Default",
    title: "Dashboard",
    meta: {
      requiresAuth: true,
    },
  },
  // Dashboard
  {
    path: "/dashboard",
    name: "Dashboard",
    redirect: "/requests",
    component: Dashboard,
    meta: {
      title: "Dashboard",
      requiresAuth: true,
    },
  },
  //
  // Projects
  {
    path: "/projects",
    name: "ProjectsOverview",
    component: ProjectsOverview,
    meta: {
      title: "Projects",
      requiresAuth: true,
    },
    children: [
      {
        path: "new",
        name: "ProjectNew",
        component: ProjectNew,
        meta: {
          title: "New project",
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: "/projects/:id",
    name: "ProjectDetail",
    component: ProjectDetail,
    meta: {
      title: "Project",
      requiresAuth: true,
    },
  },
  // Requests
  {
    path: "/requests",
    name: "Requests",
    component: Requests,
    meta: {
      title: "Requests",
      requiresAuth: true,
    },
    children: [
      {
        path: ":id",
        name: "UrlDetail",
        component: UrlDetail,
        meta: {
          title: "Request",
          requiresAuth: true,
        },
      },
      {
        path: "",
        component: UrlEmpty,
        meta: {
          title: "Request",
          requiresAuth: true,
        },
      },
    ],
  },
  // Export
  {
    path: "/export",
    name: "Export",
    component: Export,
    meta: {
      title: "Export",
      requiresAuth: true,
    },
  },
  // Settings
  {
    path: "/settings",
    name: "Settings",
    component: Settings,
    children: [
      {
        path: "billing",
        name: "Billing",
        component: Billing,
        meta: {
          title: "Billing",
          requiresAuth: true,
        },
      },
      {
        path: "general",
        name: "SettingsGeneral",
        component: General,
        meta: {
          title: "Settings",
          requiresAuth: true,
        },
      },
      {
        path: "headers",
        name: "SettingsHeaders",
        component: Headers,
        meta: {
          title: "Headers",
          requiresAuth: true,
        },
      },
      {
        path: "profile",
        name: "Profile",
        component: Profile,
        meta: {
          title: "Profile",
          requiresAuth: true,
        },
      },
      {
        path: "account/delete",
        name: "AccountDelete",
        component: AccountDelete,
        meta: {
          title: "Delete account",
          requiresAuth: true,
        },
      },
      {
        path: "account/password",
        name: "Password",
        component: Password,
        meta: {
          title: "Change password",
          requiresAuth: true,
        },
      },
      {
        path: "account/email",
        name: "Email",
        component: Email,
        meta: {
          title: "Change email",
          requiresAuth: true,
        },
      },
    ],
    meta: {
      requiresAuth: true,
    },
  },
  // Confirm an email address
  {
    path: "/confirm/:userId",
    name: "UserConfirmEmail",
    component: UserConfirmEmail,
    meta: {
      title: "Confirm email address",
      requiresAuth: false,
    },
  },
  //
  // Confirm a change email address
  {
    path: "/confirm/email/:userId",
    name: "UserConfirmChangeEmail",
    component: UserConfirmChangeEmail,
    meta: {
      title: "Confirm email address",
      requiresAuth: false,
    },
  },
  //
  // Default login page
  {
    path: "/login",
    name: "login",
    component: Login,
    meta: {
      title: "Login",
      requiresAuth: false,
    },
  },
  //
  // Default registration,
  // only asking for an email address
  {
    path: "/signup",
    name: "signup",
    component: Signup,
    meta: {
      title: "Signup",
      requiresAuth: false,
    },
  },
  //
  // Step 2 of the registration process
  // Asking for more user details
  {
    path: "/signup/:userId",
    name: "signupStep2",
    component: SignupStep2,
    meta: {
      title: "Signup",
      requiresAuth: false,
    },
  },
  //
  // Request a new confirmation email
  {
    path: "/resend",
    name: "UserResendConfirmation",
    component: UserResendConfirmation,
    meta: {
      title: "Resend confirmation email",
      requiresAuth: false,
    },
  },
  //
  // Request a reset password code
  {
    path: "/reset",
    name: "UserResetPassword",
    component: UserResetPassword,
    meta: {
      title: "Reset password",
      requiresAuth: false,
    },
  },
  //
  // Set a new password
  {
    path: "/reset/:userId",
    name: "UserResetPasswordStep2",
    component: UserResetPasswordStep2,
    meta: {
      title: "Reset password",
      requiresAuth: false,
    },
  },
  {
    path: "/*",
    name: "PageNotFound",
    component: PageNotFound,
    meta: {
      title: "Page not found",
      requiresAuth: false,
    },
  },
  // {
  // path: "/about",
  // name: "about",
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  // component: () =>
  // import(/* webpackChunkName: "about" */ "../views/About.vue")
  // }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

//
// Navigation guard.
// Meta values determine if a user can route to a certain page or be blocked
// https://router.vuejs.org/guide/advanced/navigation-guards.html#global-guards
import store from "@/store";

router.beforeEach((to, from, next) => {
  //
  // Only continue if from and to paths are different
  if (from.fullPath === to.fullPath) {
    next(false);
  } else {
    if (to.meta.requiresAuth) {
      //
      // If a user is not logged in
      // redirect them to the Login page
      // @ts-ignore
      if (store.getters["authentication/isAuthenticated"]) {
        next();
      } else {
        next({ name: "login" });
      }
    } else {
      next();
    }
  }
});

export default router;
